
import React, { useState } from 'react';
import NavigationSection from './NavigationSection';
import OrganizationSectionContent from './OrganizationSection';
import SystemSectionContent from './SystemSection';
import IntegrationsSectionContent from './IntegrationsSection';

interface SettingsNavigationProps {
  activeTab: string;
  onChange: (value: string) => void;
}

const SettingsNavigation = ({ activeTab, onChange }: SettingsNavigationProps) => {
  return (
    <div className="flex flex-col space-y-4 w-full sm:w-56">
      <NavigationSection 
        title="Organization" 
        emoji="👥" 
        defaultOpen={true}
      >
        <OrganizationSectionContent activeTab={activeTab} onChange={onChange} />
      </NavigationSection>
      
      <NavigationSection 
        title="System Configuration" 
        emoji="⚙️" 
        defaultOpen={true}
      >
        <SystemSectionContent activeTab={activeTab} onChange={onChange} />
      </NavigationSection>
      
      <NavigationSection 
        title="Integrations" 
        emoji="🔌" 
        defaultOpen={false}
      >
        <IntegrationsSectionContent activeTab={activeTab} onChange={onChange} />
      </NavigationSection>
    </div>
  );
};

export default SettingsNavigation;
